module.exports = __webpack_public_path__ + "2020celebration/img/s4.6f6743f7.png";